import { createContext } from 'react';
import {
	TFileId,
	ICreateSubCategoryValidationError,
	IItemForGetShortInfo,
	IItemForGetShortInfoWithStatus,
	IServerError,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	ICreateSubCategory,
} from 'types';

export type TVisibleForm = 'mainForm' | 'translations';
export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'defaultTranslationIsEmpty';

export interface ICreateSubCategoryState {
	visibleForm: TVisibleForm;
	fileId: TFileId;
	fetchedCustomers: IItemForGetShortInfo[];
	IDSelectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfoWithStatus[];
	IDsSelectedRestaurant: string[];
	nameOfSubCategory: string;
	fetchedCategories: IItemForGetShortInfo[];
	IDSelectedCategory: Nullable<string>;
	IDsOfRestaurantsWhereToHide: string[];
	IDsOfRestaurantsAvailableForRepetition: string[];
	activationSchedule: string;
	deactivationSchedule: string;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: TLanguageIDs | null;
	translations: IMenuTranslation[];
	dataForSubmit: ICreateSubCategory | null;
	typeOfModalWindow: TTypeOfModalWindow;
	errorResponse: IServerError<ICreateSubCategoryValidationError> | null;
}

export const createSubCategoryInitialState: ICreateSubCategoryState = {
	visibleForm: 'mainForm',
	fileId: null,
	fetchedCustomers: [],
	IDSelectedCustomer: null,
	fetchedRestaurants: [],
	IDsSelectedRestaurant: [],
	nameOfSubCategory: '',
	fetchedCategories: [],
	IDSelectedCategory: null,
	IDsOfRestaurantsWhereToHide: [],
	IDsOfRestaurantsAvailableForRepetition: [],
	activationSchedule: '',
	deactivationSchedule: '',
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
	errorResponse: null,
};

export interface ICreateSubCategoryContext extends ICreateSubCategoryState {
	changeVisibleForm(value: TVisibleForm): void;
	setFileId(value: TFileId): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: Nullable<string>): void;
	setFetchedRestaurants(value: IItemForGetShortInfoWithStatus[]): void;
	setIDsRestaurant(value: string[]): void;
	changeNameOfSubCategory(value: string): void;
	setFetchedCategories(value: IItemForGetShortInfo[]): void;
	setIDCategory(value: Nullable<string>): void;
	setIDsOfRestaurantsWhereToHide(value: string[]): void;
	setIDsOfRestaurantsAvailableForRepetition(value: string[]): void;
	changeActivationSchedule(value: string): void;
	changeDeactivationSchedule(value: string): void;
	setFetchedTranslations(value: TLanguageIDs[], defaultCustomerLanguage: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: TLanguageIDs | null): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(value: ICreateSubCategory | null): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	showErrorModalWithInfo(errorResponseData: IServerError<ICreateSubCategoryValidationError> | null): void;
	resetFields(): void;
}

export const CreateSubCategoryContext = createContext<ICreateSubCategoryContext>({
	changeVisibleForm: () => undefined,
	setFileId: () => undefined,
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	setFetchedRestaurants: () => undefined,
	setIDsRestaurant: () => undefined,
	changeNameOfSubCategory: () => undefined,
	setFetchedCategories: () => undefined,
	setIDCategory: () => undefined,
	setIDsOfRestaurantsWhereToHide: () => undefined,
	setIDsOfRestaurantsAvailableForRepetition: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	setFetchedTranslations: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	showErrorModalWithInfo: () => undefined,
	resetFields: () => undefined,
	...createSubCategoryInitialState,
});
